import { UntypedFormGroup, ValidationErrors } from '@angular/forms';

export function atLeastOneChecked(group: UntypedFormGroup): ValidationErrors | null {
  const atLeastOneChecked =
    group &&
    group?.controls &&
    Object.keys(group.controls).some((k) => group.controls[k].value);

  return atLeastOneChecked ? null : { atLeastOne: true };
}
